import { HttpProvider } from "../http/http.provider";
import { IAppConfig } from "../http/types/IApplicationConfig";
import { addProvider, IProviderDescriptor, ServiceEndpointConstants } from "../ServiceUtil";
import { Observable } from "rxjs";
import { share, map } from "rxjs/operators";
import { createFormData } from "../util/utilities";
import { IHttpRequestConfig } from "../http";
import { INewInsurancePlanData, InsurancePlanDetailResponse, InsurancePlanResponse, InsuranceProvider } from "./insuranceProvider.interface";
import { CreateInsuranceProviderRequest,InsuranceProviderResponse,InsurancePlan,InsuranceDetailData } from "./insuranceProvider.interface";
/**
 *
 */
 
export class InsuranceProviderDelegate
{
    constructor(private SERVICE_CONFIG: IAppConfig, private http: HttpProvider)
    {
    }
 
    public getAllProviders(orgId: string): Observable<InsuranceProviderResponse>
    {
        const config: IHttpRequestConfig = { params: { orgId } };
        return this.http.get(ServiceEndpointConstants.endpoints.BENEFITS.GET_ALL_INSURANCE_PROVIDERS, null, config).pipe(
            map((response: any) => ({
                insuranceProviders: this.normalizeProviders(response.data.insuranceProviders),
                success: response.data.success
            })),
            share()
        );
    }
 
    public createNewInsuranceProvider(insurance: CreateInsuranceProviderRequest): Observable<InsuranceProviderResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.BENEFITS.CREATE_INSURANCE_PROVIDER, insurance).pipe(
            map((response: any) => ({
                insuranceProviders: this.normalizeProviders(response.data.insuranceProviders),
                insuranceProviderId: response.data.insuranceProviderId,
                success: response.data.success
            })),
            share()
        );
    }
 
    public getProviderById(insuranceProviderId: number): Observable<InsuranceProviderResponse>
    {
        const config: IHttpRequestConfig = { params: { InsuranceProviderId: insuranceProviderId } };
        return this.http.get(ServiceEndpointConstants.endpoints.BENEFITS.GET_INSURANCE_PROVIDER_BY_ID, null, config).pipe(
            map((response: any) => ({
                insuranceProvider: this.normalizeProvider(response.data.insuranceProvider),
                insuranceProviderId,
                success: response.data.success
            })),
            share()
        );
    }
 
    public createNewInsurancePlan(insurancePlanData: INewInsurancePlanData): Observable<InsurancePlanResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.BENEFITS.CREATE_INSURANCE_PLAN, createFormData(insurancePlanData)).pipe(
            map((response: any) => ({
                insurancePlans: this.normalizStInsuancePlans(response.data.insurancePlans),
                insurancePlanId: response.data.insurancePlanId,
                success: response.data.success
            })),
            share()
        );
    }
 
     public updateInsurancePlan(insurancePlan: INewInsurancePlanData): Observable<InsurancePlanResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.BENEFITS.UPDATE_INSURANCE_PLAN, createFormData(insurancePlan)).pipe(
            map((response: any) => ({
                insurancePlans: this.normalizStInsuancePlans(response.data.insurancePlans),
                success: response.data.success
            })),
            share()
        );
    }
 
    public createInsurancePlanDetails(planDetails: InsuranceDetailData): Observable<InsurancePlanDetailResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.BENEFITS.CREATE_INSURANCE_PLAN_DATA, createFormData(planDetails)).pipe(
            map((response: any) => ({
                insuranceDetailData: this.normalizeInsuranceDetail(response.data.insuranceDetails),
                insuranceDetailId: response.data.insuranceDetailId,
                success: response.data.success
            })),
            share()
        );
    }
 
     public updateInsurancePlanDetails(planDetails: InsuranceDetailData): Observable<InsurancePlanDetailResponse>
    {
        return this.http.post(ServiceEndpointConstants.endpoints.BENEFITS.UPDATE_INSURANCE_PLAN_DATA, createFormData(planDetails)).pipe(
            map((response: any) => ({
                insuranceDetailData: this.normalizeInsuranceDetail(response.data.insuranceDetails),
                success: response.data.success
            })),
            share()
        );
    }
 
    private normalizeProviders(insuranceProviders: any[]): InsuranceProvider[]
    {
        return insuranceProviders.map(p => this.normalizeProvider(p));
    }
 
    private normalizeProvider(insuranceProvider: any): InsuranceProvider
    {
        insuranceProvider.stInsurancePlans       = this.normalizStInsuancePlans(insuranceProvider.stInsurancePlans);
        insuranceProvider.healthInsurancePlanData = this.normalizStInsuancePlans(insuranceProvider.healthInsurancePlanData);
        insuranceProvider.dentalInsurancePlanData = this.normalizStInsuancePlans(insuranceProvider.dentalInsurancePlanData);
        insuranceProvider.visionInsurancePlanData = this.normalizStInsuancePlans(insuranceProvider.visionInsurancePlanData);
        return insuranceProvider;
    }
 
    private normalizStInsuancePlans(plans: any[]): InsurancePlan[]
    {
        return plans.map(plan =>
        {
            plan.insuranceDetailData = this.normalizeInsuranceDetail(plan.insuranceDetailData);
            return plan;
        });
    }
 
    private normalizeInsuranceDetail(details: any[]): InsuranceDetailData[]
    {
        return details.map(detail => detail);
    }
}